import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
// TODO - fix this import when we can import thunderbolt-commmons properly
import { getImpliedLinks } from '@wix/thunderbolt-commons/dist/links';
import {
  WRichTextDefinition,
  WRichTextProps,
  WRichTextSelectorCSSVars as WRichTextSelectorCSSCarmiData,
} from '@wix/thunderbolt-components';

export const props = withCompInfo<
  WRichTextProps,
  WRichTextDefinition,
  WRichTextProps
>()(
  ['isMobileView', 'isQaMode', 'fullNameCompType'],
  ({ isMobileView, isQaMode, fullNameCompType }, carmiData) => {
    return {
      ...carmiData,
      html: getImpliedLinks(carmiData.html, isMobileView),
      isQaMode,
      fullNameCompType,
    };
  },
);

export const css = withCompInfo<
  WRichTextSelectorCSSCarmiData,
  WRichTextDefinition,
  WRichTextSelectorCSSCarmiData
>()([], (_deps, carmiCss) => {
  return carmiCss;
});

export default createComponentMapperModel({ props });
